import {
  faBriefcaseArrowRight,
  faUserTag
} from '@fortawesome/pro-solid-svg-icons'
import { Badge } from '~/components/Global/Blocks/Badge/Badge'
import type { StatusUpdateEvent } from '~/domains/actions/types'
import { BaseHistoryCard } from './BaseHistoryCard'

export const StatusUpdateHistoryCard = ({
  event
}: {
  event: StatusUpdateEvent
}) => {
  return (
    <BaseHistoryCard
      event={event}
      icon={event.orderStatus ? faBriefcaseArrowRight : faUserTag}
      title={
        <>
          {event.orderStatus?.name && (
            <Badge
              title={event.orderStatus.name}
              backgroundColor={event.orderStatus.color}
            />
          )}
          {event.status?.name && (
            <Badge
              title={
                event.archiveType
                  ? `${event.status.name} (${event.archiveType.name})`
                  : event.status.name
              }
              backgroundColor={event.status.color}
            />
          )}
        </>
      }
    />
  )
}
